import Image from "next/image";
import React from "react";
import NoImageFound from "../NoImageFound";
import { addWidthParam, addArchivedClass } from "@/lib/utils";

interface AuctionEndedImageProps {
  image: string;
  text?: any;
  mainText?: string;
  /** Auction cover image (small source) rather than a lot photo. */
  cover?: boolean;
}

const AuctionEndedImage: React.FC<AuctionEndedImageProps> = ({
  image,
  text = "Ingen bild hittades",
  mainText,
  cover = false,
}) => {
  return (
    <div className="relative w-full h-full duration-500 transition-all group select-none">
      <div className="absolute text-base md:text-2xl top-0 left-0 h-full w-full flex justify-center text-center items-center uppercase text-white font-bold p-3 z-[100]">
        <span className="group-hover:hidden">
          {mainText}
        </span>
      </div>
      <div className="bg-black/20 z-10 absolute top-0 left-0 w-full h-full group-hover:bg-transparent transition-all duration-500"></div>
      {image === "" ? (
        <NoImageFound
          text={text}
          containerClass="relative h-full max-h-[200px] md:max-h-[270px] w-full object-cover overflow-hidden shrink-0 hover:scale-115 transition-all duration-1000 cursor-zoom-in select-none"
        />
      ) : (
        <Image
          className="relative w-fullh h-full object-cover overflow-hidden shrink-0 hover:scale-115 transition-all duration-1000 cursor-zoom-in select-none max-h-[200px] md:max-h-[270px]"
          src={addArchivedClass(image, 800, cover ? "cover" : "photo")}
          alt="Slider Image"
          height="500"
          width="400"
        />
      )}
    </div>
  );
};

export default AuctionEndedImage;
